import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IPromotionsCategories } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IApiResponse, IMetaResponse, ISelectOption } from '@/shared';
import { camelizePromotionsCategories } from '@/shared/helpers/camelize-promotions-categories';
import { IPromotionsCategoriesCamel } from '@/shared/interfaces/promotions-categories';

// Base store configuration
const adminGatewayResourcePath: string = '/property-api/promotions-categories';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IPromotionsCategories>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

interface IPromotionsCategoriesState {
  list: IApiResponse<IPromotionsCategories[], IMetaResponse> | null;
  single: IApiResponse<IPromotionsCategories, IMetaResponse> | null;
}

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
    promotionsCategoriesOptions(state: IPromotionsCategoriesState): ISelectOption[] {
      return state.list?.data?.map((pc) => ({ text: pc.title, value: pc.id })) || [];
    },
    camelCasePromotionsCategories(state: IPromotionsCategoriesState): IPromotionsCategoriesCamel[] {
      return camelizePromotionsCategories(state.list?.data || []);
    },
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
